export { default as useCacheDeleteQuery } from './useCacheDeleteQuery';
